import React, { useMemo } from 'react';
import moment from 'moment';

import { useGetDistributorSubscribersInvestmentsQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import withProducts from './withProductSelectHOC';
import DataContainer from './DataContainer';

const getMappedData = data => {
    const noData = !data.length || !data.find(d => d.value !== null);
    if (noData) return [];
    return [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map(
        i => data.find(d => +d.MONTH === moment().subtract(i, 'month').get('M') + 1)?.value || 0
    );
};

const SubscriptionsFlux = props => {
    const { products, product, setProduct } = props;
    const selectedProductName = useMemo(
        () => (product === 'all' ? texts.ALL_1 : products.find(p => p.id === +product)?.name),
        [products, product]
    );

    const { data = { time_grouped_invested_sums: [] }, isFetching: loading } =
        useGetDistributorSubscribersInvestmentsQuery({
            groupBy: 'MONTH',
            fundId: product === 'all' ? undefined : +product,
        });

    const series = useMemo(() => {
        const mappedData = getMappedData(data.time_grouped_invested_sums);
        return mappedData.length ? [{ name: selectedProductName, data: mappedData }] : [];
    }, [data, selectedProductName]);

    return (
        <DataContainer
            title={texts.TOTAL_SUBSCRIPTIONS_FLUX}
            products={products}
            chartSeries={series}
            product={product}
            setProduct={setProduct}
            loading={loading}
        />
    );
};

export default withProducts(SubscriptionsFlux);
